import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 347.61 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#93c7ef",
			d: "M173.8 357.21c-42.676 0-77.395 34.72-77.395 77.395s34.719 77.396 77.395 77.396 77.395-34.72 77.395-77.395-34.719-77.396-77.395-77.396z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#78b9eb",
			d: "M173.8 512c42.676 0 77.395-34.72 77.395-77.395s-34.72-77.395-77.395-77.395"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffad41",
			d: "M296.26 50.471C263.451 17.893 220.014 0 173.81 0c-.419 0-.843.002-1.262.004-45.274.32-88.091 18.097-120.56 50.058C19.507 82.031 1.059 124.56.045 169.822c-1.066 47.514 16.713 92.286 50.059 126.07 18.076 18.312 28.443 42.832 28.443 67.272v17.86h190.51v-17.86c0-24.583 10.191-48.925 27.96-66.785 32.623-32.791 50.588-76.323 50.588-122.57 0-46.657-18.235-90.458-51.343-123.33z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff9811",
			d: "M296.26 50.471C263.451 17.893 220.014 0 173.81 0h-.012v381.02h95.256v-17.86c0-24.583 10.191-48.925 27.96-66.785 32.623-32.791 50.588-76.323 50.588-122.57 0-46.657-18.235-90.458-51.343-123.33z"
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#fff",
			transform: "translate(-82.197)",
			children: [
				/* @__PURE__ */ _jsx("path", { d: "M314.09 185.15L289.21 210.03 314.47 235.29 364.61 185.15 314.47 135.02 289.21 160.28z" }),
				/* @__PURE__ */ _jsx("path", { d: "M197.53 135.02L147.39 185.15 197.53 235.29 222.79 210.03 197.91 185.15 222.79 160.28z" }),
				/* @__PURE__ */ _jsx("path", { d: "M222.83 256L259.34 256 289.17 114.31 252.66 114.31z" })
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#beddf5",
			d: "M78.547 363.16H269.057V434.60200000000003H78.547z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#93c7ef",
			d: "M173.8 363.16H269.05600000000004V434.60200000000003H173.8z"
		})
	]
});
export default SvgLogo;
